/**
 * Moduli abilitati alla stampa dei documenti.
 *
 * La rotta runtime `/print/:templateId` apre il motore di stampa su un
 * documento reale: ci arriva chi sta lavorando quel documento, non solo chi
 * disegna i template. Proteggerla con il solo `impostazioni.report` mostrava
 * la pagina "Accesso negato" a ogni operativo che premeva Stampa / Email.
 *
 * L'elenco rispecchia la mappa `MODULO_PER_ENTITA` di
 * `backend/src/config/moduliStampa.js`: se lì si aggiunge un entitaType, va aggiunto
 * anche qui il modulo corrispondente.
 */
export const MODULI_STAMPA = [
  'impostazioni.report',
  'commerciale.commesse',
  'commerciale.capitolati',
  'commerciale.offerte_capitolato',
  'commerciale.preventivi',
  'commerciale.ddt',
  'commerciale.fatture_attive',
  'commerciale.sal',
  'commerciale.ordini_clienti',
  'commerciale.distinte',
  'commerciale.acconti',
  'acquisti.ordini_fornitori',
  'magazzino.movimenti',
  'management.report_dati_societa',
  'controllo_gestione.movimenti_analitici',
  'controllo_gestione.bilancio_analitico',
  'bop_go.import_ordini_smartix',
];
